(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heading-collection"]) return;
  try {
    
class DescriptionShort extends HTMLElement {
  constructor() {
    super();
    this.readMoreButton = this.querySelector('[data-read-more]');
    this.readLessButton = this.querySelector('[data-read-less]');
    this.shortDescription = this.querySelector('.hdt-collection-description-short');
    this.fullDescription = this.querySelector('.hdt-collection-description-full');
    if (!this.readMoreButton || !this.readLessButton || !this.shortDescription || !this.fullDescription) return;

    this.readMoreButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.shortDescription.classList.add('hdt-hidden');
      this.fullDescription.classList.remove('hdt-hidden');
    });
    this.readLessButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.shortDescription.classList.remove('hdt-hidden');
      this.fullDescription.classList.add('hdt-hidden');
    });
  }
}

customElements.define('description-short', DescriptionShort);

(() => {
  if (!document.querySelector('.hdt-main-collection-content, .hdt-main-search')) return;

  let facetLayoutUnlockTimer = 0;
  let facetLayoutStyleInjected = false;

  function ensureFacetLayoutLockStyle() {
    if (facetLayoutStyleInjected || document.getElementById('hdt-facet-layout-lock-style')) return;
    const style = document.createElement('style');
    style.id = 'hdt-facet-layout-lock-style';
    style.textContent = `
      @media (min-width: 1150px) {
        [main-content][data-facet-layout-lock="1"] .hdt-row-flex .hdt-shop-sidebar.hdt-col {
          width: var(--hdt-facet-sidebar-width) !important;
          min-width: var(--hdt-facet-sidebar-width) !important;
          max-width: var(--hdt-facet-sidebar-width) !important;
          flex: 0 0 var(--hdt-facet-sidebar-width) !important;
        }
        [main-content][data-facet-layout-lock="1"] .hdt-row-flex .hdt-shop-content.hdt-col,
        [main-content][data-facet-layout-lock="1"] .hdt-row-flex .hdt-search-results-content.hdt-col {
          width: var(--hdt-facet-content-width) !important;
          min-width: var(--hdt-facet-content-width) !important;
          max-width: var(--hdt-facet-content-width) !important;
          flex: 0 0 var(--hdt-facet-content-width) !important;
        }
      }
      [main-content][data-facet-layout-lock="1"] .hdt-active-filters {
        min-height: var(--hdt-facet-active-filters-height, auto) !important;
      }
      [main-content][data-facet-layout-lock="1"] .hdt-row-flex {
        min-height: var(--hdt-facet-row-min-height, auto) !important;
      }
    `;
    document.head.appendChild(style);
    facetLayoutStyleInjected = true;
  }

  function getFacetMainContentFromEvent(event) {
    const sectionFromTarget = event?.target?.closest?.('.shopify-section');
    if (sectionFromTarget) {
      return sectionFromTarget.querySelector('[main-content]');
    }

    const sectionIdFromUrl = event?.detail?.url?.searchParams?.get?.('section_id');
    if (sectionIdFromUrl) {
      return document.getElementById(`shopify-section-${sectionIdFromUrl}`)?.querySelector('[main-content]');
    }

    return document.querySelector('[main-content]');
  }

  function lockFacetLayoutDuringRender(event) {
    if (window.innerWidth < 1150) return;
    const mainContent = getFacetMainContentFromEvent(event);
    if (!mainContent) return;
    ensureFacetLayoutLockStyle();

    const row = mainContent.querySelector('.hdt-row-flex');
    if (!row) return;

    const sidebar = row.querySelector('.hdt-shop-sidebar.hdt-col');
    const content = row.querySelector('.hdt-shop-content.hdt-col, .hdt-search-results-content.hdt-col');
    if (!sidebar || !content) return;

    const sidebarWidth = Math.round(sidebar.getBoundingClientRect().width);
    const contentWidth = Math.round(content.getBoundingClientRect().width);
    const rowHeight = Math.round(row.getBoundingClientRect().height);

    if (sidebarWidth > 80) {
      mainContent.style.setProperty('--hdt-facet-sidebar-width', `${sidebarWidth}px`);
    }

    if (contentWidth > 120) {
      mainContent.style.setProperty('--hdt-facet-content-width', `${contentWidth}px`);
    }

    if (rowHeight > 120) {
      mainContent.style.setProperty('--hdt-facet-row-min-height', `${rowHeight}px`);
    }

    const activeFilters = mainContent.querySelector('.hdt-active-filters');
    if (activeFilters) {
      const activeHeight = Math.round(activeFilters.getBoundingClientRect().height);
      if (activeHeight > 0) {
        mainContent.style.setProperty('--hdt-facet-active-filters-height', `${activeHeight}px`);
      }
    }

    mainContent.dataset.facetLayoutLock = '1';
  }

  function unlockFacetLayoutAfterRender() {
    clearTimeout(facetLayoutUnlockTimer);
    facetLayoutUnlockTimer = setTimeout(() => {
      document.querySelectorAll('[main-content][data-facet-layout-lock="1"]').forEach((mainContent) => {
        mainContent.style.removeProperty('--hdt-facet-sidebar-width');
        mainContent.style.removeProperty('--hdt-facet-content-width');
        mainContent.style.removeProperty('--hdt-facet-row-min-height');
        mainContent.style.removeProperty('--hdt-facet-active-filters-height');
        delete mainContent.dataset.facetLayoutLock;
      });
    }, 180);
  }

  function initFacetSingleOpenAccordions(dom = document) {
    const facetForms = dom.querySelectorAll('hdt-facet-filters-form');
    facetForms.forEach((facetForm) => {
      const groups = facetForm.querySelectorAll('details.hdt-filter-group');
      if (!groups.length) return;
      groups.forEach((group) => {
        if (group.dataset.singleFacetBound === '1') return;
        group.addEventListener('toggle', () => {
          if (!group.open) return;
          groups.forEach((otherGroup) => {
            if (otherGroup !== group) {
              otherGroup.removeAttribute('open');
            }
          });
        });
        group.dataset.singleFacetBound = '1';
      });

      const openGroups = Array.from(groups).filter((group) => group.open);
      if (openGroups.length === 0) {
        groups[0].setAttribute('open', '');
        return;
      }

      if (openGroups.length > 1) {
        openGroups.forEach((group, index) => {
          if (index > 0) {
            group.removeAttribute('open');
          }
        });
      }
    });
  }

  function onGloboSwatchClick(event) {
    const swatch = event.target.closest('.spf-product__swatch');
    if (!swatch) return;

    const swatchGroup = swatch.closest('.spf-product__swatchs');
    const productCard = swatch.closest('.spf-product-card');
    const select = productCard?.querySelector('select.spf-product__variants');
    const addToCartButton = productCard?.querySelector('.hdt-button-add-to-cart__btn');
    if (!swatchGroup || !select || !addToCartButton) return;

    swatchGroup.querySelectorAll('.spf-product__swatch').forEach((item) => item.classList.remove('is-selected'));
    swatch.classList.add('is-selected');

    const selectedValues = {};
    productCard.querySelectorAll('.spf-product__swatchs .spf-product__swatch.is-selected').forEach((item) => {
      const optionIndex = item.getAttribute('data-option');
      const optionValue = item.getAttribute('data-option-value');
      selectedValues[`data-option${optionIndex}`] = optionValue;
    });

    const matchedOption = Array.from(select.options).find((option) => {
      return Object.entries(selectedValues).every(([key, value]) => option.getAttribute(key) === value);
    });

    if (matchedOption) {
      addToCartButton.setAttribute('data-variant-id', matchedOption.value);
      select.value = matchedOption.value;
    }
  }

  document.addEventListener('facet:render', lockFacetLayoutDuringRender);
  ['theme4:facet:updated', 'hdt:facet:render'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      lockFacetLayoutDuringRender(event);
      const root = getFacetMainContentFromEvent(event) || document;
      root.dispatchEvent(new CustomEvent('products:update', { bubbles: true }));
    });
  });
  document.addEventListener('mox:products:ready', (event) => {
    initFacetSingleOpenAccordions(event.target);
    unlockFacetLayoutAfterRender();
  });

  window.addEventListener('globoFilterRenderCompleted', () => {
    if (!window.__hdtGloboSwatchBound) {
      document.addEventListener('click', onGloboSwatchClick);
      window.__hdtGloboSwatchBound = true;
    }

    const root = document.querySelector('[main-content]') || document;
    root.dispatchEvent(new CustomEvent('products:update', { bubbles: true }));
  });

  initFacetSingleOpenAccordions(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-order-list"] && !Shopify.designMode) return;
  try {
    
Promise.all([
  import('@theme/global'),
  import('@theme/events')
]).then(([{ $4, $$4, formatMoney, debounce, getterAdd, getterRunFn }, { CartUpdateEvent, ThemeEvents }]) => {
  // quick order list

  var createCartPromise = () => {
    return new Promise(async (resolve) => {
      resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
    });
  };
  var _upate_qty,
    upate_qty_fn;
  class QuickOrderList extends HTMLElement {
    constructor() {
      super();
      const ON_CHANGE_DEBOUNCE_TIMER = 300;
      this.actions = {
        add: 'ADD',
        update: 'UPDATE',
      };
      this.quickOrderListId = '#' + this.id;
      this.sectionId = this.dataset.sectionId;
      this.updateThink();

      const debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, ON_CHANGE_DEBOUNCE_TIMER);

      this.addEventListener('change', debouncedOnChange.bind(this));
      getterAdd(_upate_qty, this);
      document.addEventListener("cart:push:section.id", (event) => event.detail.sections.push(this.sectionId));
    }
    onSubmit(event) {
      event.preventDefault();
    }

    connectedCallback() {
      document.addEventListener(ThemeEvents.cartUpdate, this.fetchQuickOrder.bind(this));
    }

    updateThink() {
      this.items_in_cart = $4('[update_items_in_cart]', this);
      this.items_price_in_cart = $4('[update_items_price_in_cart]', this);
      $4('form#QuickOrderList', this).addEventListener('submit', this.onSubmit.bind(this));
    }
    async fetchQuickOrder(event) {
      try {
        const sectionHtml = event.detail?.cartData?.sections?.[this.sectionId] || await fetch(`${window.location.pathname}?section_id=${this.sectionId}`).then(response => response.text());
        const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const sourceQty = html.querySelector(this.quickOrderListId);
        if (!sourceQty) return;
        this.innerHTML = sourceQty.innerHTML;
        document.dispatchEvent(new CustomEvent("currency:update"));
        this.updateThink();
      } catch (error) {
        console.error(error);
      }
    }
    onChange(event) {
      const inputValue = parseInt(event.target.value);
      const cartQuantity = parseInt(event.target.dataset.cartQuantity);
      const index = event.target.dataset.quantityVariantId;
      const quantity = inputValue - cartQuantity;

      if (cartQuantity > 0) {
        this.updateQuantity(index, inputValue, this.actions.update);
      } else {
        this.updateQuantity(index, quantity, this.actions.add);
      }
    }
    onLoading(id) {
      $4(`#Variant-${id} [price_loading]`, this)?.setAttribute('aria-busy', true);
      $$4('#hdt-quick-order-list-total .hdt-btn-loading__svg', this).forEach(el => el.setAttribute('aria-busy', true));
    }
    deLoading(id) {
      $4(`#Variant-${id} [price_loading]`, this)?.setAttribute('aria-busy', false);
      $$4('#hdt-quick-order-list-total .hdt-btn-loading__svg', this).forEach(el => el.setAttribute('aria-busy', false));
    }
    removeButton(id, quantity) {
      quantity !== 0 ? $4(`#Variant-${id} hdt-quick-order-list-remove-button`, this).removeAttribute('hidden') : $4(`#Variant-${id} hdt-quick-order-list-remove-button`, this).setAttribute('hidden', '');
    }
    updateInCart(id, variant_in_cart) {
      //  label
      $4(`#Variant-${id} .hdt-quantity__rules-cart`, this).removeAttribute('hidden');
      let variant_qty_cart = $4(`#Variant-${id} .hdt-quantity-cart`, this);

      //  totals
      let variant_total = $4(`#Variant-${id} [variant_update_price]`, this);

      // update
      if (variant_in_cart?.length !== 0 && variant_in_cart) {
        let variant_total_price = parseFloat(variant_in_cart.original_line_price)
        variant_qty_cart.innerText = variant_in_cart.quantity
        variant_total.innerText = formatMoney(variant_total_price, themeHDN.settings.currencyFormat);
        variant_total.setAttribute('data-variant-price', variant_total_price);
      } else {
        variant_qty_cart.innerText = 0;
        variant_total.innerText = formatMoney(0, themeHDN.settings.currencyFormat);
        variant_total.setAttribute('data-variant-price', 0);
        $4(`#Variant-${id} .hdt-quantity__rules-cart`, this).setAttribute('hidden', '');
      }
      this.removeT4CrurrencyData(variant_total);
    }
    removeT4CrurrencyData(el, dataset = el.dataset) {
      for (const [key, value] of Object.entries(dataset)) {
        if (key.toLowerCase().indexOf("currency") >= 0) delete el.dataset[key];
      }
    }
    updateTotalInCart() {
      let items_total = 0;
      let items_price = 0;

      // update items_total
      let items = $$4('[data-cart-quantity]', this);
      items.forEach(item => {
        return items_total += parseInt(item.getAttribute('data-cart-quantity'));
      })
      this.items_in_cart.innerText = items_total;

      // update items_price
      let prices = $$4('[data-variant-price]', this);
      prices.forEach(price => {
        return items_price += parseFloat(price.getAttribute('data-variant-price'));
      })
      this.items_price_in_cart.innerText = formatMoney(items_price, themeHDN.settings.currencyFormat);
      this.removeT4CrurrencyData(this.items_price_in_cart);
      document.dispatchEvent(new CustomEvent("currency:update"));
    }

    fetchConfig(type = 'json') {
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
      };
    }
    // update quantity product
    updateQuantity(id, quantity, action) {
      document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: !0 }));
      this.removeButton(id, quantity);
      this.onLoading(id);
      let bundleSections = [];
      document.dispatchEvent(new CustomEvent("cart:push:section.id", { bubbles: true, detail: { sections: bundleSections } }));
      const cartDrawerSection = document.querySelector('hdt-cart-drawer')?.getAttribute('section-id');
      if (cartDrawerSection && !bundleSections.includes(cartDrawerSection)) bundleSections.push(cartDrawerSection);
      let routeUrl = `${Shopify.routes.root}cart/change.js`;
      let body = JSON.stringify({
        quantity,
        id,
        sections_url: window.location.pathname,
        sections: bundleSections.join(",")
      });
      let fetchConfigType;

      if (action === this.actions.add) {
        fetchConfigType = 'javascript';
        routeUrl = `${Shopify.routes.root}cart/add.js`;
        body = JSON.stringify({
          items: [
            {
              quantity: parseInt(quantity),
              id: parseInt(id),
            },
          ],
          sections_url: window.location.pathname,
          sections: bundleSections.join(",")
        });
      }

      fetch(`${routeUrl}`, { ...this.fetchConfig(fetchConfigType), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          let cartContent = JSON.parse(state);
          const quantityElement = document.getElementById(`Quantity-${id}`);

          if (quantity === 0) {
            this.resetQuantityInput(id, quantityElement, true);
          }
          quantityElement.setAttribute('data-cart-quantity', quantity);
          getterRunFn(_upate_qty, this, upate_qty_fn).call(this, cartContent, parseInt(id), action, bundleSections)
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.updateTotalInCart();
          document.dispatchEvent(new CustomEvent("currency:update"));
          document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: !0 }));
          this.deLoading(id);
        });
    }
    resetQuantityInput(id, quantityElement, resetValue) {
      const input = quantityElement ?? document.getElementById(`Quantity-${id}`);
      input.value = input.getAttribute('value');
      resetValue ? input.value = 0 : input.value = input.getAttribute('value');
    }
    updateError(updatedValue, id) {
      let message = '';
      if (typeof updatedValue === 'undefined') {
        message = window.cartStrings.error;
      } else {
        message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
      }
      this.updateLiveRegions(id, message);
    }

    updateLiveRegions(id, message) {
      const variantItemError = this.getElementById('Quick-order-list-item-error');
      if (variantItemError) {
        $4('.hdt-variant-item__error-text', variantItemError).innerHTML = message;
        variantItemError.removeAttribute('hidden');
      }
    }

  }
  _upate_qty = new WeakSet();
  upate_qty_fn = async function (cartContent, id, action) {
    const variant_in_cart = cartContent.items.find((item) => item.variant_id === id);
    this.updateInCart(id, variant_in_cart);
    this.dispatchEvent(new CustomEvent("quickOrder:change", { bubbles: false }));
    //document.dispatchEvent(new CustomEvent("cart:refresh"));
    let cart = cartContent;
    if (action === this.actions.add) {
      cart = await createCartPromise();
      cart.sections = cartContent.sections;
    }
    document.dispatchEvent(new CartUpdateEvent({}, this.sectionId, cart, "no_action", "quick-order-list"));
  };

  customElements.define('hdt-quick-order-list', QuickOrderList);

  // remove variant in cart
  class QuickOrderListRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const quickOrderList = this.closest('hdt-quick-order-list');
        quickOrderList.updateQuantity(this.dataset.index, 0);
        this.setAttribute('hidden', '');
      });
    }
  }

  customElements.define('hdt-quick-order-list-remove-button', QuickOrderListRemoveButton);

  // remove all variant in cart
  class QuickOrderListRemoveAllButton extends HTMLElement {
    constructor() {
      super();
      this.quickOrderList = this.closest('hdt-quick-order-list');
      const allVariants = Array.from(this.quickOrderList.querySelectorAll('[data-variant-id]'));
      const items = {};
      const list_variants = []
      let hasVariantsInCart = false;

      allVariants.forEach((variant) => {
        const cartQty = parseInt(variant.dataset.cartQty);
        if (cartQty > 0) {
          hasVariantsInCart = true;
          items[parseInt(variant.dataset.variantId)] = 0;
          list_variants.push(variant.dataset.variantId);
        }
      });

      if (!hasVariantsInCart) {
        this.setAttribute('hidden', '')
      }

      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.quickOrderList.updateMultipleQty(items, list_variants);
        this.setAttribute('hidden', '')
      });
    }
  }

  customElements.define('hdt-quick-order-list-remove-all-button', QuickOrderListRemoveAllButton);
});

  } catch(e) { console.error(e); }
})();
})();
